import React from 'react';
import { GridItem } from 'src/components/common/OrentaGrid';
import { WrapperText, Header2, Description } from './information.styles';

const Information = () => {

    return (
        <>
            <GridItem lg={1}>
                <></>
            </GridItem>
            <GridItem lg={10}>
                <WrapperText sepTop={'57px'}>
                    <Header2 align={'center'} color={'white'}><div>Impulsa el bienestar de tus equipos y fortalece tu empresa.</div></Header2>
                    <Description>Te ayudamos en el cumplimiento de la Norma-035 para identificar, analizar y prevenir factores de riesgo psicosocial. Compártenos tu información y un asesor se comunicará contigo para agendar una demostración.</Description>
                </WrapperText>
            </GridItem>
            <GridItem lg={1} >
                <></>
            </GridItem>
        </>
              
    );
};

export default Information;
